import Unit from "./Unit";

export default function BuildingA({ units, onToggle, onName }) {
  return (
    <div className="building">
      <h3>Building A</h3>

      <div className="grid grid-8">
        <div className="split">
          <Unit number="11" data={units["11"]} onToggle={onToggle} onName={onName} />
          <Unit number="10" data={units["10"]} onToggle={onToggle} onName={onName} />
        </div>

        {["12","13","14","15","16","17","18"].map((n) => (
          <Unit key={n} number={n} data={units[n]} onToggle={onToggle} onName={onName} tall />
        ))}
      </div>
    </div>
  );
}
